import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initCsrf } from "./lib/api";
import { silentRefresh } from "./auth";

// Boot sequence: CSRF first (GET — no auth needed), then restore session via cookie
(async () => {
  await initCsrf();        // GET /auth/csrf-token — works without a token
  // Skip refresh on the login page — no session to restore, avoids 401 console noise
  if (!window.location.pathname.startsWith("/login")) {
    await silentRefresh(); // POST /auth/refresh — now has CSRF token in memory
  }
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<App />);
})();
